import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoader } from "../../../context/LoaderContext";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";
import { failed, success } from "../../../hooks/useToast";
import axios from "axios";
import { headers } from "../../../exports/exports";
import { Radio, FormControlLabel } from "@mui/material";
import { getFormattedDate } from "../../../exports/functions";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";

const EditMember = () => {
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = useMobile();
  const tab = useTab();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const memberData = location.state?.memberData;
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [preview, setPreview] = useState<string | null>(null);
  const [approvalStatus, setApprovalStatus] = useState<string>("");
  const [rejectionReason, setRejectionReason] = useState<string>("");
  const [previousStatus, setPreviousStatus] = useState<string>();

  const [firstname, setFirstname] = useState<string>("");
  const [middlename, setMiddlename] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [designation, setDesignation] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [qualifications, setQualifications] = useState<string>("");
  const [mobilenumber, setMobileNumber] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [selectedProfileImage, setSelectedProfileImage] = useState<File>();
  const [membershipType, setMembershipType] = useState<string>("");
  const [membershipExpiry, setMembershipExpiry] = useState<number>(0);
  const [memberDescription, setMemberDescription] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const token = localStorage.getItem("frcsit:access-token");
  const sisheaders = { Authorization: `Bearer ${token}` };

  const [open, setOpen] = useState(false);

  const lightboxSlides = memberData?.attributes?.Payment_Reciept?.data
    ?.slice()
    .sort(
      (a: any, b: any) =>
        new Date(b?.attributes?.createdAt).getTime() -
        new Date(a?.attributes?.createdAt).getTime()
    )
    .map((item: any) => {
      const mimeType = item?.attributes?.mime;
      const url = item?.attributes?.url;
      const createdAt = item?.attributes?.createdAt;
      const formattedDate = new Date(createdAt).toISOString().split("T")[0];

      if (mimeType?.startsWith("image")) {
        return {
          type: "image",
          src: `${process.env.REACT_APP_strapiUrl}${url}`,
          description: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>{formattedDate}</span>
              <a
                href={`${process.env.REACT_APP_strapiUrl}${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
              >
                View
              </a>
            </div>
          ),
        };
      }

      if (mimeType === "application/pdf") {
        return {
          type: "image",
          src: "https://cdn-icons-png.flaticon.com/512/4208/4208479.png",
          description: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>{formattedDate}</span>
              <a
                href={`${process.env.REACT_APP_strapiUrl}${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
              >
                View
              </a>
            </div>
          ),
        };
      }

      return null;
    })
    .filter(Boolean);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [setLoading]);

  useEffect(() => {
    setFirstname(memberData?.attributes?.First_Name);
    setMiddlename(memberData?.attributes?.Middle_Name);
    setLastname(memberData?.attributes?.Last_Name);
    setDesignation(memberData?.attributes?.Designation);
    setCountry(memberData?.attributes?.Country);
    setQualifications(memberData?.attributes?.Qualifications);
    setMobileNumber(memberData?.attributes?.Mobile_Number);
    setEmail(memberData?.attributes?.Email);
    setMembershipType(memberData?.attributes?.Type_Of_Membership);
    setStatus(memberData?.attributes?.Status);
    setPreviousStatus(
      memberData?.attributes?.Status === "Activate"
        ? "approved"
        : memberData?.attributes?.Status === "Reject"
        ? "rejected"
        : ""
    );
    setApprovalStatus(
      memberData?.attributes?.Status === "Activate"
        ? "approved"
        : memberData?.attributes?.Status === "Reject"
        ? "rejected"
        : ""
    );
    setMemberDescription(memberData?.attributes?.Description);
    setMembershipExpiry(memberData?.attributes?.Membership_Valid);
  }, [memberData]);

  const handleEditClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreview(url);
      setSelectedProfileImage(file);
    }
  };

  const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
  const validateStep = () => {
    let newErrors: { [key: string]: string } = {};
    if (!firstname) newErrors.firstname = "First Name is required";
    if (!designation) newErrors.designation = "Designation is required";
    if (!country) newErrors.country = "Location is required";
    if (!qualifications)
      newErrors.qualifications = "Specialization are required";
    if (!mobilenumber) {
      newErrors.mobilenumber = "Phone Number is required";
    } else if (!/^\d{10}$/.test(mobilenumber)) {
      newErrors.mobilenumber = "Phone Number must be exactly 10 digits";
    }
    if (!email) newErrors.email = "Email is required";
    else if (!isValidEmail(email)) newErrors.email = "Invalid email format";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validateStep()) {
      return;
    }
    let uploadedImageId = null;
    setLoading(true);
    const formattedDate = getFormattedDate(membershipExpiry, 0);
    try {
      const locationDetail = {
        area_name: "Chhauni",
        street_name: "Kakancho Binayak Marg",
        nearest_landmark: "",
        municipalities_id: 332,
        district_id: 28,
        province_id: 3,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_locationUrl}/location`,
        locationDetail,
        {
          headers: sisheaders,
        }
      );

      if (res?.status === 200 || res?.status === 201) {
        const userDetail = {
          name: firstname,
          phone_no: mobilenumber,
          address: JSON.stringify({
            area_name: { id: res?.data?.area_id },
            street_name: { id: res?.data?.street_id },
            nearest_landmark: "",
            municipalities_id: 332,
            district_id: 28,
            province_id: 3,
          }),
          email: email,
          gender: memberData?.attributes?.Sex === "male" ? 1 : 2,
          dob: "2000-01-01T00:00:00+05:45",
          //   password: password,
          //   password_confirmation: reenterPassword,
          status: status === "Activate" ? 1 : 0,
          roles: ["member"],
          profile_pic: null,
        };
        const userRes = await axios.put(
          `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users/${memberData?.attributes?.sis_id}`,
          userDetail,
          {
            headers: sisheaders,
          }
        );
        if (userRes?.status === 200 || userRes?.status === 201) {
          if (selectedProfileImage) {
            const formData = new FormData();
            formData.append("files", selectedProfileImage);

            const uploadRes = await axios.post(
              `${process.env.REACT_APP_strapiUrl}/api/upload`,
              formData,
              {
                headers: {
                  Authorization: headers.Authorization,
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            uploadedImageId = uploadRes.data[0].id;
          }
          const data = {
            data: {
              Email: email,
              First_Name: firstname,
              Last_Name: lastname,
              Designation: designation,
              Qualifications: qualifications,
              Mobile_Number: mobilenumber,
              Country: country,
              Status: status,
              Description: memberDescription,
              ...(uploadedImageId && { Profile_Picture: uploadedImageId }),
              ...(approvalStatus === "approved" && {
                Membership_Expiry:
                  memberData?.attributes?.Membership_Expiry &&
                  memberData?.attributes?.Status === "Pending"
                    ? new Date(
                        new Date(
                          memberData?.attributes?.Membership_Expiry
                        ).setFullYear(
                          new Date(
                            memberData?.attributes?.Membership_Expiry
                          ).getFullYear() + 1
                        )
                      )
                        .toISOString()
                        .split("T")[0]
                    : formattedDate,
              }),
            },
          };
          axios
            .put(
              `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberData?.id}`,
              data,
              {
                headers: headers,
              }
            )
            .then(async () => {
              if (
                previousStatus !== "approved" &&
                approvalStatus === "approved"
              ) {
                const now = new Date();
                const time = now.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                });
                // const now = new Date();
                // now.setMinutes(now.getMinutes() + 2); // Add 2 minutes

                // const time = now.toLocaleTimeString([], {
                //   hour: "2-digit",
                //   minute: "2-digit",
                //   hour12: false,
                // });
                // const formattedDate = getFormattedDate(0, -7);
                const oneMonthBefore = getFormattedDate(membershipExpiry, 0, 1);
                const oneWeekBefore = getFormattedDate(membershipExpiry, 7);
                const oneDayBefore = getFormattedDate(membershipExpiry, 1);
                // const notificationDate = getFormattedDate(0, 0);
                const currentYear = getFormattedDate(0, 0);
                await axios.post(
                  `${process.env.REACT_APP_NOTIFICATION_URL}/scheduled-notification`,
                  {
                    sisOrganizationId: 80,
                    payload: {
                      FullName: `${firstname} ${middlename} ${lastname}`
                        .replace(/\s+/g, " ")
                        .trim(),
                      MembershipType: membershipType,
                      ExpirationDate: formattedDate,
                      CurrentYear: currentYear.slice(0, 4),
                    },
                    notificationTemplateId:
                      "15246d73-2633-451f-bcb9-6a5751e4b21d",
                    scheduledNotificationTime: time,
                    scheduledNotificationDate: [
                      oneMonthBefore,
                      oneWeekBefore,
                      oneDayBefore,
                    ],
                    scheduledNotificationReceivers: [
                      {
                        sisID: 1232,
                        email: email,
                      },
                    ],
                    scheduledNotificationSender: 5171,
                  }
                );
                await axios.post(
                  `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
                  {
                    templateId: "e5bbfc23-6037-4f2e-bc10-dcb42e4cb615",
                    senderId: 5171,
                    payload: {
                      FullName: `${firstname} ${middlename} ${lastname}`
                        .replace(/\s+/g, " ")
                        .trim(),
                      CurrentYear: currentYear.slice(0, 4),
                    },
                    users: [
                      {
                        sisID: 1232,
                        email: email,
                      },
                    ],
                  }
                );
              } else if (approvalStatus === "rejected") {
                const currentYear = getFormattedDate(0, 0);
                await axios.post(
                  `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
                  {
                    templateId: "ef451502-86ba-4aec-9e41-9e330037b88d",
                    senderId: 5171,
                    payload: {
                      FullName: `${firstname} ${middlename} ${lastname}`
                        .replace(/\s+/g, " ")
                        .trim(),
                      reasonMessage: rejectionReason,
                      CurrentYear: currentYear.slice(0, 4),
                    },
                    users: [
                      {
                        sisID: 1232,
                        email: email,
                      },
                    ],
                  }
                );
              }
              setPreviousStatus(approvalStatus);
              setRejectionReason("");
              setLoading(false);
              success();
            })
            .catch(() => failed());
        } else {
          failed();
        }
      }
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      <section
        className="events-page"
        style={{
          padding: "0px 0px 20px 0px",
          // marginTop: (!mobile && !tab) ? "88px" : "unset",
          marginLeft: !mobile && !tab ? "240px" : "unset",
        }}
      >
        <div className="container">
          <div
            className="section-title custom-text-center"
            style={{ marginBottom: "unset" }}
          >
            <h2 className="section-title__title custom-user-section-title">
              Edit Member
            </h2>
          </div>

          <div className="row">
            <div
              className="col-xl-12"
              style={{ marginTop: mobile || tab ? "10px" : "unset" }}
            >
              <div className="quality-work__tab-box tabs-box">
                <div
                  className="custom-feature-two"
                  style={{ padding: "16px", backgroundColor: "transparent" }}
                >
                  <div className="row">
                    <div className="user-card__header">
                      <div
                        className="user-card__info"
                        style={{ marginLeft: "unset", textAlign: "end" }}
                      >
                        <button
                          onClick={() => navigate(-1)}
                          className="thm-btn become-volunteer__btn"
                        >
                          <i className="icon-arrow-left2"></i>
                          Back
                        </button>
                      </div>
                    </div>
                    <hr />
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Member First Name *</span>
                        <input
                          type="text"
                          placeholder="First Name*"
                          name="firstname"
                          value={firstname}
                          onChange={(e) => setFirstname(e.target.value)}
                          className={errors.firstname && "error-border"}
                        />
                        {errors.firstname && (
                          <p className="error-message">{errors.firstname}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Designation *</span>
                        <input
                          type="text"
                          placeholder="Designation*"
                          name="designation"
                          value={designation}
                          onChange={(e) => setDesignation(e.target.value)}
                          className={errors.designation && "error-border"}
                        />
                        {errors.designation && (
                          <p className="error-message">{errors.designation}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Member Last Name *</span>
                        <input
                          type="text"
                          placeholder="Last Name*"
                          name="lastname"
                          value={lastname}
                          onChange={(e) => setLastname(e.target.value)}
                          className={errors.lastname && "error-border"}
                        />
                        {errors.lastname && (
                          <p className="error-message">{errors.lastname}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Location *</span>
                        <input
                          type="text"
                          placeholder="Location*"
                          name="location"
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                          className={errors.lastname && "error-border"}
                        />
                        {errors.country && (
                          <p className="error-message">{errors.country}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Specialization *</span>
                        <input
                          type="text"
                          placeholder="Specialization*"
                          name="specialization"
                          value={qualifications}
                          onChange={(e) => setQualifications(e.target.value)}
                          className={errors.qualifications && "error-border"}
                        />
                        {errors.qualifications && (
                          <p className="error-message">
                            {errors.qualifications}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Phone No. *</span>
                        <input
                          type="number"
                          placeholder="Phone No.*"
                          name="phoneno"
                          value={mobilenumber}
                          onChange={(e) => setMobileNumber(e.target.value)}
                          className={errors.mobilenumber && "error-border"}
                        />
                        {errors.mobilenumber && (
                          <p className="error-message">{errors.mobilenumber}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Email *</span>
                        <input
                          type="text"
                          placeholder="Email*"
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className={errors.email && "error-border"}
                        />
                        {errors.email && (
                          <p className="error-message">{errors.email}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Status *</span>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                            marginTop: "8px",
                            marginBottom:
                              approvalStatus === "rejected" ? "8px" : "unset",
                          }}
                        >
                          <FormControlLabel
                            value="Pending"
                            control={
                              <Radio
                                checked={status === "Pending"}
                                onChange={() => {
                                  setStatus("Pending");
                                  setApprovalStatus("");
                                }}
                                sx={{
                                  color:
                                    status === "Pending" ? "yellow" : "gray",
                                  "&.Mui-checked": {
                                    color: "yellow",
                                  },
                                }}
                              />
                            }
                            label="Pending"
                            sx={{
                              border: `1px solid ${
                                status === "Pending" ? "yellow" : "#ccc"
                              }`,
                              borderRadius: "5px",
                              padding: "2px 10px",
                              color: status === "Pending" ? "yellow" : "gray",
                              backgroundColor: "transparent",
                              marginLeft: "unset",
                              marginRight: "unset",
                            }}
                          />

                          <FormControlLabel
                            value="Activate"
                            control={
                              <Radio
                                checked={status === "Activate"}
                                onChange={() => {
                                  setStatus("Activate");
                                  setApprovalStatus("approved");
                                }}
                                sx={{
                                  color:
                                    status === "Activate" ? "green" : "gray",
                                  "&.Mui-checked": {
                                    color: "green",
                                  },
                                }}
                              />
                            }
                            label="Activate"
                            sx={{
                              border: `1px solid ${
                                status === "Activate" ? "green" : "#ccc"
                              }`,
                              borderRadius: "5px",
                              padding: "2px 10px",
                              color: status === "Activate" ? "green" : "gray",
                              backgroundColor: "transparent",
                              marginLeft: "unset",
                              marginRight: "unset",
                            }}
                          />

                          <FormControlLabel
                            value="Reject"
                            control={
                              <Radio
                                checked={status === "Reject"}
                                onChange={() => {
                                  setStatus("Reject");
                                  setApprovalStatus("rejected");
                                }}
                                sx={{
                                  color: status === "Reject" ? "red" : "gray",
                                  "&.Mui-checked": {
                                    color: "red",
                                  },
                                }}
                              />
                            }
                            label="Reject"
                            sx={{
                              border: `1px solid ${
                                status === "Reject" ? "red" : "#ccc"
                              }`,
                              borderRadius: "5px",
                              padding: "2px 10px",
                              color: status === "Reject" ? "red" : "gray",
                              backgroundColor: "transparent",
                              marginLeft: "unset",
                              marginRight: "unset",
                            }}
                          />
                          <FormControlLabel
                            value="Expire"
                            control={
                              <Radio
                                checked={status === "Expire"}
                                onChange={() => {
                                  setStatus("Expire");
                                  setApprovalStatus("");
                                }}
                                sx={{
                                  color:
                                    status === "Expire" ? "darkred" : "gray",
                                  "&.Mui-checked": {
                                    color: "darkred",
                                  },
                                }}
                              />
                            }
                            label="Expired"
                            sx={{
                              border: `1px solid ${
                                status === "Expire" ? "darkred" : "#ccc"
                              }`,
                              borderRadius: "5px",
                              padding: "2px 10px",
                              color: status === "Expire" ? "darkred" : "gray",
                              backgroundColor: "transparent",
                              marginLeft: "unset",
                              marginRight: "unset",
                            }}
                          />
                        </div>
                        {approvalStatus === "rejected" && (
                          <div className="col-xl-12">
                            <div
                              className="become-volunteer__input become-volunteer__message-box"
                              style={{ height: "100px" }}
                            >
                              <textarea
                                name="reason"
                                placeholder="Reason For Rejection"
                                value={rejectionReason}
                                onChange={(e) =>
                                  setRejectionReason(e.target.value)
                                }
                                style={{ height: "100px" }}
                              ></textarea>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input custom-file-input">
                        <span>Profile Image</span>
                        {preview ? (
                          <>
                            <div
                              className="user-card__image"
                              style={{ cursor: "default" }}
                            >
                              <img src={preview} alt="User" />
                              <div
                                className="edit-profil-pic-icon"
                                style={{ top: "23px", left: "65px" }}
                                onClick={handleEditClick}
                              >
                                <span className="icon-pencil"></span>
                              </div>
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />
                          </>
                        ) : memberData?.attributes?.Profile_Picture?.data ? (
                          <>
                            <div
                              className="user-card__image"
                              style={{ cursor: "default" }}
                            >
                              <img
                                src={`${process.env.REACT_APP_strapiUrl}${memberData.attributes.Profile_Picture.data.attributes.url}`}
                                alt="User"
                              />
                              <div
                                className="edit-profil-pic-icon"
                                style={{ top: "23px", left: "65px" }}
                                onClick={handleEditClick}
                              >
                                <span className="icon-pencil"></span>
                              </div>
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />
                          </>
                        ) : (
                          <>
                            <label
                              htmlFor="profile-image-upload"
                              style={{ cursor: "pointer" }}
                            >
                              {"Upload Image"}
                            </label>
                            <input
                              type="file"
                              id="profile-image-upload"
                              accept=".png,.jpg,.jpeg"
                              onChange={handleFileChange}
                              style={{ display: "none" }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <span>Membership Type</span>
                        <input
                          type="text"
                          placeholder="Membership Type"
                          name="membershiptype"
                          value={membershipType}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="become-volunteer__input">
                        <label
                          onClick={() => setOpen(true)}
                          className="thm-btn welcome-one__btn"
                          style={{ cursor: "pointer" }}
                        >
                          View Receipt
                        </label>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="become-volunteer__input become-volunteer__message-box">
                        <span>Member Description</span>
                        <textarea
                          name="memberdescription"
                          placeholder="Member Description"
                          value={memberDescription}
                          onChange={(e) => setMemberDescription(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div
                    className="become-volunteer__btn-box"
                    style={{ textAlign: "center", marginTop: "10px" }}
                  >
                    <button
                      type="submit"
                      className="thm-btn become-volunteer__btn"
                      onClick={() => handleSubmit()}
                    >
                      Update Member
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={lightboxSlides}
        plugins={[Counter, Zoom, Thumbnails, Captions]}
      />
    </>
  );
};

export default EditMember;
